import { render, staticRenderFns } from "./ProductSettingsPanel.vue?vue&type=template&id=e21512b2"
import script from "./ProductSettingsPanel.vue?vue&type=script&lang=js"
export * from "./ProductSettingsPanel.vue?vue&type=script&lang=js"
import style0 from "./ProductSettingsPanel.vue?vue&type=style&index=0&id=e21512b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports